import * as React from 'react';
import { useSelector } from 'react-redux';

import ErrorAlert from 'components/ErrorAlert';
import { Modal } from 'semantic-ui-react';

import { Step } from 'components/StepProgress';
import Wizard from 'components/Wizard';
import {
    FERTILIZER_EVENT_CREATE_NAMESPACE,
    FERTILIZER_EVENT_UPDATE_NAMESPACE
} from 'services/fertilizerEvents/constants';
import { FertilizerEventUuid } from 'services/fertilizerEvents/types';
import { AppState } from 'services/types';
import {
    FERTILIZER_EVENT_WIZARD_SCHEDULE_STEP,
    FERTILIZER_EVENT_WIZARD_APPLICATION_STEP,
    FERTILIZER_EVENT_WIZARD_PRODUCT_STEP,
    FERTILIZER_EVENT_WIZARD_SUMMARY_STEP
} from './constants';

import FertilizerEventApplicationPage from './components/FertilizerEventApplicationPage';
import FertilizerEventProductPage from './components/FertilizerEventProductPage';
import {
    selectInitialValues,
    selectFertilizerEventIsCompleted
} from './selectors';
import FertilizerEventSummaryPage from './components/FertilizerEventSummaryPage';
import FertilizerEventSchedulePage from './components/FertilizerEventAreaPage';
import FertilizerEventReadOnlySummaryPage from './components/FertilizerEventReadOnlySummaryPage';

export interface OwnProps {
    handleSubmit: Function;
    fertilizerEventUuid?: FertilizerEventUuid;
    namespace: Namespace;
    title: string;
    isEditing?: boolean;
}

export type Props = OwnProps;

export type Namespace =
    | typeof FERTILIZER_EVENT_CREATE_NAMESPACE
    | typeof FERTILIZER_EVENT_UPDATE_NAMESPACE;

const steps: Step[] = [
    {
        description: 'Schedule',
        value: FERTILIZER_EVENT_WIZARD_SCHEDULE_STEP
    },
    {
        description: 'App.',
        value: FERTILIZER_EVENT_WIZARD_APPLICATION_STEP
    },
    {
        description: 'Product',
        value: FERTILIZER_EVENT_WIZARD_PRODUCT_STEP
    },
    {
        description: 'Summary',
        value: FERTILIZER_EVENT_WIZARD_SUMMARY_STEP
    }
];

export default function FertilizerEventForm(props: Props): React.ReactElement {
    const { handleSubmit, namespace, title, isEditing = false } = props;

    const initialValues = useSelector((state: AppState) =>
        selectInitialValues(state, props)
    );

    const fertilizerEventIsCompleted = useSelector((state: AppState) =>
        selectFertilizerEventIsCompleted(state, props)
    );

    if (fertilizerEventIsCompleted && isEditing) {
        return (
            <FertilizerEventReadOnlySummaryPage initialValues={initialValues} />
        );
    }

    return (
        <React.Fragment>
            <Modal.Header>{title}</Modal.Header>
            <Modal.Content>
                <Wizard
                    onSubmit={handleSubmit}
                    steps={steps}
                    classname="spray-event-modal || constrain-width"
                    initialValues={initialValues}
                    namespace={namespace}
                >
                    <Wizard.Page>
                        <FertilizerEventSchedulePage isEditing={isEditing} />
                        <ErrorAlert namespace={namespace} />
                    </Wizard.Page>
                    <Wizard.Page>
                        <FertilizerEventApplicationPage />
                        <ErrorAlert namespace={namespace} />
                    </Wizard.Page>
                    <Wizard.Page>
                        <FertilizerEventProductPage />
                        <ErrorAlert namespace={namespace} />
                    </Wizard.Page>
                    <Wizard.Page>
                        <FertilizerEventSummaryPage />
                        <ErrorAlert namespace={namespace} />
                    </Wizard.Page>
                </Wizard>
            </Modal.Content>
        </React.Fragment>
    );
}
